<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1-part"><a id="part01"><span class="txbf">PART ONE</span></a></h1><a id="part01">
<h1 class="h1title"><span class="txbfit">The Clouded Levels</span></h1>
<p class="block">If there are gods, they do not help, and justice belongs to the strong: but know that all things done before the naked stars are remembered.</p>
<p class="attrb">—Klingon proverb</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?1ceb81b2